import { ListItem, IconButton, Collapse } from '@material-ui/core';
import React, { useState } from 'react';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import videoIcon from "../../images/video.png";
import slidesIcon from "../../images/slides.png";
import readingIcon from "../../images/reading.png";
import homeworkIcon from "../../images/homework.png";
import workshopIcon from "../../images/workshop.png";
import LessonIcon from './LessonIcon';
import { useHistory } from 'react-router';
import { adminOrTeacher } from '../../utils/validation';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import DeleteOutlineTwoToneIcon from '@mui/icons-material/DeleteOutlineTwoTone';
import breakpoint from "../../helpers/breakpoints";

const LessonLine = ({ lesson = {}, index, removeLessonById, currentUser }) => {
    const { date, shortTitle, title, video, slides, workshop, homework, group, reading, _id: id } = lesson;
    const [isOpen, setIsOpen] = useState(false);
    const history = useHistory();

    return <ListItem style={{
        paddingLeft: '0.28rem',
        paddingTop: '2.39rem',
        paddingBottom: isOpen ? '0.556rem' : '2.39rem',
        minHeight: '6.22rem',
        borderTop: index === 0 ? '1px solid var(--placeholder-text)' : 'none',
        borderBottom: '1px solid var(--placeholder-text)',
        width: ['XS'].includes(breakpoint()) ? '80%' : '100%'
    }}>
        <div style={{ width: '100%' }}>
            <div style={{
                height: '1.667rem',
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between'
            }}>
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}>
                    <span style={{ marginRight: index + 1 >= 10 ? '0.667rem' : '1.111rem', fontSize: '1.111rem' }}>{index + 1}.</span><span>{shortTitle}</span>
                </div>
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}>
                    <IconButton onClick={() => setIsOpen(!isOpen)}>
                        {isOpen ? <KeyboardArrowUpIcon style={{ height: '1.111rem', width: '1.111rem', border: '1px solid var(--regular-text)' }} />
                            :
                            <KeyboardArrowDownIcon style={{ height: '1.111rem', width: '1.111rem', border: '1px solid var(--regular-text)' }} />}
                    </IconButton>
                </div>
            </div>
            <Collapse in={isOpen} timeout="auto" unmountOnExit>
                {adminOrTeacher(currentUser) &&
                    <div className='admin-edit-icons'>
                        <IconButton onClick={() => history.push(`/lesson/update/${id}`)}><EditTwoToneIcon fontSize='small' /></IconButton>
                        <IconButton onClick={() => removeLessonById(id, group)}><DeleteOutlineTwoToneIcon fontSize='small' /></IconButton>
                    </div>
                }
                <div className={['S', 'XS'].includes(breakpoint()) ? "lesson-info-sm" : "lesson-info"}>
                    {title && <div >{title}</div>}
                    {date && <div >{date}</div>}
                </div>
                <div className='lesson-materials'>
                    <div style={{ display: 'flex' }}>
                        <LessonIcon src={videoIcon} text='video' link={video} />
                        {slides && <LessonIcon src={slidesIcon} text='slides' link={slides} />}
                        {workshop && <LessonIcon src={workshopIcon} text='workshop' link={workshop} />}
                        {homework && <LessonIcon src={homeworkIcon} text='homework' link={homework} />}
                        {reading && <LessonIcon src={readingIcon} text='reading' link={reading} />}
                    </div>
                </div>
            </Collapse>
        </div>
    </ListItem>
}

export default LessonLine